import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col } from "react-bootstrap";
import onlineResourcesBanner from "../../Images/academic/elearning-banner.webp";
import { Link } from "react-router-dom";
import studentInformation from "../../Images/commonimg/acadcemics-3.webp";
import eLibrary from "../../Images/commonimg/acadcemics-4.webp";
import recordedLectures from "../../Images/commonimg/acadcemics-4.webp";
import studyMaterial from "../../Images/commonimg/mission-library.webp";
import lms from "../../Images/commonimg/lms.webp";

const OnlineResources = () => {
  return (
    <>
      <title>ISBM University Comprehensive Online Learning Resources</title>
      <meta name="Access ISBM University's online resources, e-libraries, live lectures & LMS for an enhanced learning experience. Expand your knowledge anytime, anywhere!" />

      <meta
        name="SearchEngines"
        content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
        DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
      />
      <meta name="Robots" content="INDEX, FOLLOW" />
      <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
      <meta name="Robots" content="INDEX,ALL" />
      <meta name="YahooSeeker" content="INDEX, FOLLOW" />
      <meta name="msnbot" content="INDEX, FOLLOW" />
      <meta name="googlebot" content="Default, follow" />
      <meta name="owner" content="isbmuniversity.edu.in/" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="2 days" />
      <meta
        property="og:title"
        content="Downloads and Online Resources | ISBM University"
      />
      <meta
        property="og:description"
        content="Access a wealth of educational materials and resources at your fingertips. Explore and download online resources curated by ISBM University for a seamless learning experience."
      />
      <meta property="og:url" content="https://isbmuniversity.edu.in/" />
      <meta
        property="og:image"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta property="og:image:alt" content="ISBM University" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ISBM University" />
      <meta
        name="twitter:title"
        content="Downloads and Online Resources | ISBM University"
      />
      <meta
        name="twitter:description"
        content="Access a wealth of educational materials and resources at your fingertips. Explore and download online resources curated by ISBM University for a seamless learning experience."
      />
      <meta
        name="twitter:image:src"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@ISBMUniversity" />
      <meta name="twitter:creator" content="@ISBMUniversity" />
      <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
      <meta property="twitter:account_id" content="758619542734053376" />
      <meta
        name="keywords"
        content="Best Online Learning Resources, Education Resources for Students, Digital Learning Resources"
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${onlineResourcesBanner})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Online Academic Resources</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Online Resources
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl text-center">
          <h2 className="modern-title section-title text-blue text-center">
            Digital Learning Ecosystem
          </h2>
          <p>
            ISBM University offers a rich suite of online academic resources to
            support student learning anytime, anywhere. Our digital platforms
            provide access to e-books, research journals, lecture videos,
            self-paced modules, past question papers, and interactive
            tools—ensuring students stay connected to learning beyond the
            classroom.
          </p>
          <p>
            From our learning management system (LMS) to digital libraries and
            online discussion forums, students can explore subject materials,
            submit assignments, and engage with faculty with ease. Whether
            pursuing undergraduate, postgraduate, or diploma programs, our
            online academic infrastructure ensures a seamless, tech-enabled
            learning experience that prepares students for today's dynamic and
            competitive world.
          </p>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          {/* Call to Action */}
          <Row>
            <Col lg={12}>
              <div className="cta-box text-center p-4 p-lg-5 bg-blue text-white rounded-3 shadow-lg">
                <h3 className="modern-title section-title text-white">
                  Dive into Smarter Learning
                </h3>
                <p className="lead mb-4">
                  Log in now to access all digital resources and enhance your
                  learning experience
                </p>
                <a
                  href="https://isbmuniversity.online/login.php"
                  className="btn btn-light btn-lg px-4 py-2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Login to Portal <i className="ti ti-arrow-right ms-2"></i>
                </a>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section className="ptb-50 bg-pink">
        <div className="container-xxl">
          {/* Resources Grid */}
          <Row>
            <Col lg={12}>
              <div className="text-center mb-5">
                <h2 className="modern-title section-title">
                  Access Our Digital Resources
                </h2>
                <p className="lead">
                  Click on any resource below to explore our digital resources
                  platforms
                </p>
              </div>

              <div className="resources-grid">
                <Row className="g-4 m-0">
                  {[
                    {
                      title: "Student Information",
                      icon: studentInformation,
                      description:
                        "Access comprehensive student profiles and details",
                      link: "https://isbmuniversity.online/login.php",
                      alt: "Two Students Working Together on a Laptop at a Library Table",
                    },
                    {
                      title: "E-Library",
                      icon: eLibrary,
                      description:
                        "Digital library with e-books and academic journals",
                      link: "https://library.isbmuniversity.ac.in/",
                      alt: "Stack of Colorful Books, a Tablet, and Stationery on a Wooden Study Desk",
                    },
                    {
                      title: "Recorded Lectures",
                      icon: recordedLectures,
                      description: " Access recorded lecture videos anytime",
                      link: "https://isbmuniversity.online/login.php",
                      alt: "Stack of Colorful Books, a Tablet, and Stationery on a Wooden Study Desk",
                    },
                    // {
                    //   title: "Pearson Study Material",
                    //   icon: studyMaterial,
                    //   description: "Premium learning resources",
                    //   link: "https://mediaconsole.pearson.com/",
                    //   alt: "Graduation Cap on Stacked Book",
                    // },
                    {
                      title: "Learning Management System",
                      icon: lms,
                      description: "Complete course management",
                      link: "https://isbmuniversity.online/login.php",
                      alt: "Laptop and Smartphone Showing Isbm Group Online Portal Login Screens",
                    },
                  ].map((resource, index) => (
                    <Col md={6} lg={6} key={index}>
                      <a
                        href={resource.link}
                        className="text-decoration-none"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Row className="resource-card bg-blue rounded-3 shadow-lg h-100 border-top border-4 border-purple w-100 m-0">
                          <Col md={6} lg={6} className="p-4">
                            <div className="resource-img">
                              <img src={resource.icon} alt={resource.alt} />
                            </div>
                          </Col>
                          <Col md={6} lg={6} className="p-4">
                            <h3 className="text-white mb-3">{resource.title}</h3>
                            <p className="text-white">{resource.description}</p>
                            <a
                              href={resource.link}
                              className="btn btn-outline-purple text-decoration-underline text-white"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Access Now
                              <i className="ti ti-arrow-right ms-2"></i>
                            </a>
                          </Col>
                        </Row>
                      </a>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default OnlineResources;
